export default "__VITE_ASSET__CVImRMag__"